module.exports = __webpack_public_path__ + "39e493d5302ccfacba1697a2f52f25ab.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hat-red-stripe-s.png
// module id = 2744
// module chunks = 0